import { useEffect, useRef } from 'react';
import Attribution from "ol/attribution";
import Extent from "ol/extent";
import GeoJSON from "ol/format/geojson";
import Map from "ol/map";
import Overlay from "ol/overlay";
import Tile from "ol/layer/tile";
import VectorLayer from "ol/layer/vector";
import VectorSource from "ol/source/vector";
import View from "ol/view";
import XYZ from "ol/source/xyz";
import interaction from "ol/interaction";
import proj from "ol/proj";
import "ol/ol.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "bootstrap-icons/font/bootstrap-icons.css";
// import "bootstrap-datetime-picker/css/bootstrap-datetimepicker.min.css";
// import "bootstrap-datetime-picker/js/bootstrap-datetimepicker.min";


function displayLogic(mapTarget, regionsData, forecastIcons, sitesCurrentMax, regionCurrentMax) {
    /**
     * Setup the global variable so we only call this once
     */

    let currentMap;
    let chartAQI;

    let anchor = document.createElement("a");
    let chartsAnchor = document.createElement("a");

    let script;
    // let loader;
    let currentSiteId;
    let updateMaxAqi = true;

    // FIXME: Pull siteMap (aka siteList) from the API or S3
    // https://cap.sonomatech.com/sites/data/siteList
    let siteMap = {"23661":{"name":"Aldino","siteId":23661,"latitude":39.5633,"longitude":-76.2039,"measuredParameters":[1,22,25,26,31,37,38]},"23675":{"name":"Ashburn","siteId":23675,"latitude":39.0244,"longitude":-77.49,"measuredParameters":[1,2,3,4,44,45,46,47,48,49]},"23669":{"name":"Aurora Hills","siteId":23669,"latitude":38.8594,"longitude":-77.0589,"measuredParameters":[1,4,5]},"27404":{"name":"Bald Eagle Recreation Center","siteId":27404,"latitude":38.81853,"longitude":-77.01039,"measuredParameters":[1,2,44,45,46,47]},"23683":{"name":"Beltsville","siteId":23683,"latitude":39.0284,"longitude":-76.8172,"measuredParameters":[1,9,22,23,24,25,27,31]},"23678":{"name":"Blackwater NWR","siteId":23678,"latitude":38.445,"longitude":-76.1114,"measuredParameters":[1,22]},"23653":{"name":"Calvert","siteId":23653,"latitude":38.53672,"longitude":-76.617195,"measuredParameters":[1]},"23704":{"name":"DCNearRoad","siteId":23704,"latitude":38.89475,"longitude":-76.95343,"measuredParameters":[2,4,5,22,25,26,28,29,31,38,44,45,46,47]},"23660":{"name":"Edgewood","siteId":23660,"latitude":39.41,"longitude":-76.2967,"measuredParameters":[1,2,22,25,26,31,37,38,44,45,46,47]},"23652":{"name":"Essex","siteId":23652,"latitude":39.310833,"longitude":-76.47444,"measuredParameters":[1,2,3,4,5,9,12,22,25,26,27,29,31,37,38,44,45,46,47,48,49]},"23655":{"name":"Fair Hill","siteId":23655,"latitude":39.7011,"longitude":-75.86,"measuredParameters":[1,2,22,25,26,31,37,38,44,45,46,47]},"23672":{"name":"Franconia","siteId":23672,"latitude":38.7717,"longitude":-77.1089,"measuredParameters":[1,2,3,9,44,45,46,47,48,49]},"23658":{"name":"Frederick Airport","siteId":23658,"latitude":39.42276,"longitude":-77.37519,"measuredParameters":[1]},"23712":{"name":"Glen Burnie","siteId":23712,"latitude":39.1694,"longitude":-76.6281,"measuredParameters":[1,22,25,26,31,37,38]},"23666":{"name":"Hagerstown","siteId":23666,"latitude":39.5656,"longitude":-77.7219,"measuredParameters":[1,2,22,25,26,31,37,38,44,45,46,47]},"23657":{"name":"Horn Point","siteId":23657,"latitude":38.5876,"longitude":-76.1408,"measuredParameters":[1,2,5,9,22,25,26,31,37,38,44,45,46,47]},"23664":{"name":"HU-Beltsville","siteId":23664,"latitude":39.0553,"longitude":-76.8783,"measuredParameters":[1,2,4,5,9,20,22,25,26,27,31,37,38,44,45,46,47]},"23676":{"name":"James S. Long Park","siteId":23676,"latitude":38.8553,"longitude":-77.6356,"measuredParameters":[1,4]},"23711":{"name":"King Greenleaf Rec Center","siteId":23711,"latitude":38.87516,"longitude":-77.01282,"measuredParameters":[2,44,45,46,47,48,49]},"27392":{"name":"Lake Montebello","siteId":27392,"latitude":39.33746,"longitude":-76.58905,"measuredParameters":[1,2,4,44,45,46,47]},"23647":{"name":"McMillan Reservoir","siteId":23647,"latitude":38.92185,"longitude":-77.013176,"measuredParameters":[1,2,3,4,5,21,22,23,24,25,26,28,29,37,38,41,44,45,46,47,48,49]},"23662":{"name":"Millington","siteId":23662,"latitude":39.3052,"longitude":-75.7972,"measuredParameters":[1,2,22,25,26,31,37,38,44,45,46,47]},"23651":{"name":"Padonia","siteId":23651,"latitude":39.462,"longitude":-76.6316,"measuredParameters":[1,2,22,25,26,31,37,38,44,45,46,47]},"23665":{"name":"PG Equestrian Center","siteId":23665,"latitude":38.81207,"longitude":-76.74419,"measuredParameters":[1,22,25,26,31,37,38]},"23659":{"name":"Piney Run","siteId":23659,"latitude":39.7058,"longitude":-79.0119,"measuredParameters":[1,2,4,5,9,12,22,25,26,27,29,31,37,38,44,45,46,47]},"23646":{"name":"River Terrace","siteId":23646,"latitude":38.8972,"longitude":-76.9528,"measuredParameters":[1,2,4,5,9,25,44,45,46,47]},"23663":{"name":"Rockville","siteId":23663,"latitude":39.1144,"longitude":-77.1069,"measuredParameters":[1,2,22,25,26,31,37,38,44,45,46,47]},"23654":{"name":"South Carroll","siteId":23654,"latitude":39.4442,"longitude":-77.0417,"measuredParameters":[1,22,25,26,31,37,38]},"23656":{"name":"Southern Maryland","siteId":23656,"latitude":38.5042,"longitude":-76.8119,"measuredParameters":[1]},"27396":{"name":"Springfield","siteId":27396,"latitude":38.7684,"longitude":-77.18347,"measuredParameters":[2,44,45,46,47]},"23649":{"name":"Takoma Rec","siteId":23649,"latitude":38.9701,"longitude":-77.016716,"measuredParameters":[1,4]}};

    let paramMap = {
        1: "Ozone (8-hr average)",
        2: "PM 2.5",
        3: "PM 10",
        5: "CO",
        9: "SO2",
        22: "TEMP",
        25: "RH",
        23: "WS",
        24: "WD"
    };

    let paramButtonMap = {
        1: "ozoneButton",
        2: "pm25Button",
        3: "pm10Button",
        5: "coButton",
        9: "so2Button",
        22: "tempButton",
        25: "rhButton",
        23: "wsButton",
        24: "wdButton"
    };

    let green = [46, 218, 46, 0.3];
    let highlightedGreen = [46, 218, 46, 0.6];
    let yellow = [252, 245, 6, 0.3];
    let highlightedYellow = [252, 245, 6, 0.8];
    let orange = [249, 120, 16, 0.3];
    let highlightedOrange = [249, 120, 16, 0.6];
    let red = [246, 27, 27, 0.3];
    let highlightedRed = [246, 27, 27, 0.6];
    let purple = [152, 0, 75, 0.3];
    let highlightedPurple = [152, 0, 75, 0.6];

    let options = {
        chart: {
            type: 'column'
        },
        title: {
            text: 'Ozone (8-hr average)'
        },
        position: {
            spacingLeft: 0,
            marginRight: 0
        },
        style: {},
        xAxis: {
            categories: [
                '1am',
                '2am',
                '3am',
                '4am',
                '5am',
                '6am',
                '7am',
                '8am',
                '9am',
                '10am',
                '11am',
                '12pm',
                '1pm',
                '2pm',
                '3pm',
                '4pm',
                '5pm',
                '6pm',
                '7pm',
                '8pm',
                '9pm',
                '10pm',
                '11pm',
                '12am'
            ],
            tickInterval: 1,
            minTickInterval: 1,
            showLastLabel: true,
            crosshair: false,
            endOnTick: false,
            labels: {
                overflow: false
            }
        },
        yAxis: {
            min: 0,
            max: 300,
            tickInterval: 50,
            title: {
                text: 'AQI'
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr>' + '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
                dataLabels: {
                    enabled: true,
                    crop: false,
                    overflow: 'none'
                },
                zones: [{
                    value: 51,
                    color: '#55BF3B'
                }, {
                    value: 101,
                    color: '#DDDF0D'
                }, {
                    value: 151,
                    color: '#f87910'
                }, {
                    value: 201,
                    color: '#DF5353'
                }, {
                    value: 301,
                    color: '#99004c'
                }]
            }
        },
        series: [{
            showInLegend: false
        }],
        lang: {
            noData: "No data has been submitted today for this parameter or monitoring site"
        },
        credits: false
    };

    window.jQuery(document).ready(function () {
        window.jQuery("#currentTab").attr('data-toggle', 'tab');
        window.jQuery(".disabled").removeClass("disabled");

        window.jQuery("#previousDay").click(function (e) {
            let dp = window.jQuery("#datePicker").data("DateTimePicker");
            let date = dp.date().subtract(1, 'days');
            dp.date(date);
        });

        window.jQuery("#nextDay").click(function (e) {
            let dp = window.jQuery("#datePicker").data("DateTimePicker");
            let date = dp.date().add(1, 'days');
            dp.date(date);
        });

        window.jQuery(".parameter-button").click(function (e) {
            const elem = window.jQuery(this);
            const param = elem.data('param');
            const date = window.jQuery('#datePicker').data('DateTimePicker').date();
            getDataForSiteParameterDate(currentSiteId, param, date, elem);
        });

        // creating maps
        let attribution = new Attribution({
            html: 'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/' +
            'rest/services/World_Street_Map/MapServer">ArcGIS</a>'
        });

        // creating region p
        let source = new VectorSource({
            features: (new GeoJSON({
                defaultDataProjection: 'EPSG:4326'
            })).readFeatures(regionsData, {
                dataProjection: 'EPSG:4326',
                featureProjection: 'EPSG:3857'
            })
        });

        let layer = new VectorLayer({
            source: source,
        });

        // FITTING MAP TO EXTENTS
        let extent = Extent.createEmpty();
        Extent.extend(extent, layer.getSource().getExtent());

        // creating currentmap
        currentMap = new Map({
            target: mapTarget,
            layers: [
                new Tile({
                    source: new XYZ({
                        attributions: [attribution],
                        url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                        'World_Street_Map/MapServer/tile/{z}/{y}/{x}'
                    })
                })
            ],
            view: new View({
                center: proj.fromLonLat([-76.904567, 38.751838]),
                zoom: 8
            }),
            interactions: interaction.defaults({
                doubleClickZoom: false,
                pinchZoom: true,
                mouseWheelZoom: true,
                pointer: false,
                select: false,
                dragPan: true
            }),
            controls: []
        });

        currentMap.getView().fit(extent, {
            minResolution: 420,
            constrainResolution: false,
            padding: [10, 5, 10, 5]
        });

        addMarkers(currentMap);

        // HANDLE RESIZING MAP WITH WINDOW
        window.jQuery(window).resize(function (e) {
            if (currentMap) {
                currentMap.getView().fit(extent, {
                    minResolution: 420,
                    constrainResolution: false,
                    padding: [10, 5, 10, 5]
                });
            }
        });

        // Replicate the logic of populating the current conditions in the template
        // after the template has finished processing and is showing all regions as "N/A"
        const allObsImages = document.querySelectorAll('#current #forecastRegionTable #northernVirginiaForecast img, #current #forecastRegionTable #suburbanDcForecast img');
        const allNA = Array.from(allObsImages).every(img => img.src === forecastIcons[6]["url"]);
        if (allNA) {
            console.log("The template failed :( We need to update the current AQI");
            if (Object.keys(forecastIcons).length
                && Object.keys(sitesCurrentMax).length
                && Object.keys(regionCurrentMax).length) {
                allObsImages.forEach((img, index) => {
                    let regionIndex = index === 0 ? 2 : index === 1 ? 1 : index + 1;
                    if (Object.keys(regionCurrentMax).length) {
                        const newIcon = getIconForCategoryCurrentMaxRegion(forecastIcons, regionCurrentMax[regionIndex], sitesCurrentMax);
                        img.src = `${newIcon}`;
                    }
                });
            }
        }


        // loader = window.jQuery(".loader");
        // window.jQuery(".display-container")[0].appendChild(loader[0]);
        // loader.show();

        initChart();

        //creating aqi gauge
        let gaugeOptions = {

            chart: {
                type: 'solidgauge',
                spacingTop: 0,
                spacingLeft: 0,
                spacingRight: 0,
                spacingBottom: 0
            },

            title: null,

            pane: {
                center: ['50%', '85%'],
                size: '140%',
                startAngle: -90,
                endAngle: 90,
                background: {
                    backgroundColor: (window.Highcharts.theme && window.Highcharts.theme.background2) || '#EEE',
                    innerRadius: '60%',
                    outerRadius: '100%',
                    shape: 'arc'
                }
            },

            tooltip: {
                enabled: false
            },

            // the value axis
            yAxis: {
                // stops: [
                // [0.10, '#55BF3B'], // green
                // [0.25, '#DDDF0D'], // yellow
                // [0.40, '#f87910'], // orange
                // [0.55, '#DF5353'], // red
                // [0.70, '#99004c'] // purple
                // ],
                lineWidth: 0,
                minorTickInterval: null,
                tickAmount: 7,
                title: {
                    y: 0
                },
                labels: {
                    y: 12
                }
            },

            plotOptions: {
                solidgauge: {
                    dataLabels: {
                        y: 0,
                        borderWidth: 0,
                        useHTML: true
                    }
                }
            }
        };

        // The aqi gauge
        chartAQI = window.Highcharts.chart('gaugeContainer', window.Highcharts.merge(gaugeOptions, {
            yAxis: {
                min: 0,
                max: 300
            },

            credits: {
                enabled: false
            },

            series: [{
                name: 'AQI',
                data: [0],
                dataLabels: {
                    format: '<div style="text-align:center"><span class="aqi-gauge-text" style="color:' +
                    ((window.Highcharts.theme && window.Highcharts.theme.contrastTextColor) || 'black') + '">{y}</span><br/>' +
                    '<span style="color:silver" id="paramLabel">Ozone (8-hr average)</span></div>'
                },
                tooltip: {
                    valueSuffix: 'AQI'
                }
            }]

        }));

    });

    function initChart() {
        let dp = window.jQuery('#datePicker');
        dp.datetimepicker({
            format: "MM/DD/YYYY",
            defaultDate: new Date(),
            showTodayButton: false,
            allowInputToggle: true,
            maxDate: new Date()
        });
        dp.datetimepicker().on('dp.change', function (e) {
            let date = e.date.valueOf();
            let selectedParam = parseInt(window.jQuery(".active-param-button").attr("data-param"));

            updateMaxAqi = true;
            getDataForSiteParameterDate(currentSiteId, selectedParam, date, window.jQuery(".active-param-button")[0]);
        });
        // loader[0].style.top = "50%";
        getDataForSiteParameterDate(23661, 1, new Date().valueOf());
        window.jQuery('#ozoneButton').addClass('active-param-button');
    }

    function getDataForSiteParameterDate(siteId, paramId, date, elem) {
        if (typeof date !== "number") {
            date = date.valueOf();
        }

        if (!window.jQuery(elem).hasClass("active-param-button")) {
            window.jQuery('button').removeClass("active-param-button");
            window.jQuery(elem).addClass("active-param-button");
        }

        if (window.jQuery(".highcharts-container").length === 0) {
            window.jQuery("#currentMap")
                // .append(loader[0])
                .opacity = 0.6;
            // loader.show();
        } else {
            window.jQuery("#aqiBarGraph")
                // .append(loader[0])
                .opacity = 0.6;
            // loader.show();
        }

        // Define a global callback function for the JSONP response
        window.siteDataCallback = (data) => {
            let siteData = data;

            if (paramId === 22) {
                options.yAxis.max = 40;
                options.yAxis.min = -20;
                options.yAxis.title.text = "Degrees Celsius";
                options.plotOptions.column.zones = [];
                window.jQuery("#gaugeDisplay")[0].style.opacity = "0.4";
            } else {
                if (paramId === 23) {
                    options.yAxis.max = 50;
                    options.yAxis.min = 0;
                    options.yAxis.title.text = "MPH";
                    options.plotOptions.column.zones = [];
                    window.jQuery("#gaugeDisplay")[0].style.opacity = "0.4";
                } else {
                    if (paramId === 24) {
                        options.yAxis.max = 400;
                        options.yAxis.min = 0;
                        options.yAxis.title.text = "Direction in Degrees";
                        options.plotOptions.column.zones = [];
                        window.jQuery("#gaugeDisplay")[0].style.opacity = "0.4";
                    } else {
                        if (paramId === 25) {
                            options.yAxis.max = 100;
                            options.yAxis.min = 0;
                            options.yAxis.title.text = "Percent";
                            options.plotOptions.column.zones = [];
                            window.jQuery("#gaugeDisplay")[0].style.opacity = "0.4";
                        } else {
                            options.yAxis.max = 300;
                            options.yAxis.min = 0;
                            options.yAxis.title.text = "AQI";
                            options.plotOptions.column.zones = [{
                                value: 51,
                                color: '#55BF3B'
                            },{
                                value: 101,
                                color: '#DDDF0D'
                            },{
                                value: 151,
                                color: '#f87910'
                            },{
                                value: 201,
                                color: '#DF5353'
                            },{
                                value: 301,
                                color: '#99004c'
                            }];
                            window.jQuery("#gaugeDisplay")[0].style.opacity = "1";
                        }
                    }
                }
            }

            if (siteData.length < 24) {
                let len = siteData.length;
                for (let i = 0; i < 24 - len; i++) {
                    siteData.push(null);
                }
            }

            for (let i = 0; i < 24; i++) {
                if (siteData[i] === -999) {
                    siteData[i] = null;
                }
            }

            options.series[0].data = siteData;
            options.title.text= paramMap[paramId];
            let chart = window.Highcharts.chart('aqiBarGraph', options);
            window.jQuery("#monitorSelect").val(siteMap[siteId]["name"]);
            window.jQuery("#aqiBarGraph").highcharts().reflow();
            window.jQuery("#gaugeContainer").highcharts().reflow();
            currentSiteId = siteId;
            hideParamButtons(siteMap[siteId]["measuredParameters"]);
            updateMaxAqiGauge(siteData, siteId, paramId);
        };

        // Create a script element that will be used to launch a jsonp request
        script = document.createElement('script');

        // Set the source to the JSONP endpoint, including the callback parameter
        script.src = "https://cap.sonomatech.com/sites/data/siteData/" + siteId + "/" + paramId + "/" + date + "?jsoncallback=siteDataCallback&_=" + Date.now();
        script.async = false;

        // // Handle script loading errors
        // script.onerror = (err) => {
        //     console.error('Failed to load site data');
        //     delete window.siteDataCallback;
        // };

        // Append the script to the document body to initiate the request
        document.body.appendChild(script);
    }

    function hideParamButtons(paramList) {
        for (let id in paramButtonMap) {
            window.jQuery('#' + paramButtonMap[id]).hide();
        }

        for (let i = 0; i < Object.keys(paramButtonMap).length; i++) {
            if (paramButtonMap.hasOwnProperty(paramList[i])) {
                window.jQuery('#' + paramButtonMap[paramList[i]]).show();
            }
        }
    }

    /****************
     Updates AQI gauge with max of current selected parameter
     ****************/
    function updateMaxAqiGauge(siteData, siteId, paramId) {
        let maxAqi = Math.max.apply(Math, siteData);

        let hour = siteData.lastIndexOf(maxAqi) + 1;
        let ampm = "";
        if ((hour < 12) || (hour == 24)) {
            ampm = "AM";
        } else {
            ampm = "PM";
        }
        hour = hour > 12 ? hour - 12 : hour;
        let formattedHour = hour != 0 ? hour + " " + ampm : "N/A";

        let maxParam = paramId;
        if (chartAQI && ([1, 2, 3, 5, 9].indexOf(maxParam) > -1)) {
            let point = chartAQI.series[0].points[0];
            let color = "";
            if (maxAqi > 0 && maxAqi < 51) {
                color = '#55BF3B';
            }
            if (maxAqi > 50 && maxAqi < 101) {
                color = '#DDDF0D';
            }
            if (maxAqi > 100 && maxAqi < 151) {
                color = '#f87910';
            }
            if (maxAqi > 150 && maxAqi < 201) {
                color = '#DF5353';
            }
            if (maxAqi > 200) {
                color = '#99004c';
            }

            chartAQI.yAxis[0].update({minColor: color, maxColor: color});
            point.update(maxAqi);
            if (siteData.length === 0) {
                window.jQuery('#paramLabel').html("N/A");
            } else {
                window.jQuery('#paramLabel').html(paramMap[maxParam] + "<br>" + formattedHour);
            }
        }
        window.jQuery(".monitor-marker").removeClass("selected-monitor");
        window.jQuery(".monitor-marker[siteid='" + siteId + "']").addClass("selected-monitor");

        window.jQuery("#gaugeContainer").highcharts().reflow();

    }

    function getSiteIdForSiteName(siteName) {
        let siteId;
        window.jQuery.each(siteMap, function (id, data) {
            if (data.name.trim() === siteName.trim()) {
                siteId = id;
            }
        });

        return parseInt(siteId);
    }

    function addMarkers(map) {
        let popup = document.createElement("div");
        popup.id = "popup";
        document.getElementById("current").appendChild(popup);

        // Popup showing the position the user clicked
        let popupOverlay = new Overlay({
            element: popup,
            positioning: 'top-center',
            offset: [20, 0]
        });
        map.addOverlay(popupOverlay);
        let element = popupOverlay.getElement();
        for (let site in siteMap) {
            if (siteMap.hasOwnProperty(site)) {
                let pos = proj.fromLonLat([siteMap[site]["longitude"], siteMap[site]["latitude"]]);
                let point = document.createElement("div");
                point.setAttribute("location", pos[0] + "," + pos[1]);
                point.setAttribute("siteId", siteMap[site]["siteId"]);
                point.className = getMonitorClass(siteMap[site]["siteId"]);

                document.getElementById("current").appendChild(point);

                // make monitor marker
                let marker = new Overlay({
                    position: pos,
                    positioning: 'center-center',
                    element: point,
                    stopEvent: false
                });

                window.jQuery(point).on('click', function (evt) {
                    chartsAnchor.setAttribute("href", "#aqiBarGraph");
                    document.getElementById("current").appendChild(chartsAnchor);
                    window.jQuery(chartsAnchor).click(function () {
                        if (window.location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                            || window.location.hostname == this.hostname) {
                            let target = window.jQuery(this.hash);
                            target = target.length ? target : window.jQuery('[name=' + this.hash.slice(1) + ']');
                            if (target.length) {
                                window.jQuery('html,body').animate({
                                    scrollTop: target.offset().top - 200
                                }, 350);
                                return false;
                            }
                        }
                    });
                    let siteId = window.jQuery(this).attr("siteId");
                    let paramId = sitesCurrentMax[siteId]["currentMaxParameter"];
                    if (paramId == 0) {
                        paramId = 1;
                    }
                    let paramButton = paramButtonMap[paramId];
                    updateMaxAqi = true;

                    getDataForSiteParameterDate(siteId, paramId, window.jQuery('#datePicker').data("DateTimePicker").date().valueOf());
                    window.jQuery('#' + paramButton).addClass('active-param-button');

                    chartsAnchor.click();
                });

                window.jQuery(point).hover(function () {
                    let id = window.jQuery(this).attr("siteId");
                    let content;

                    if (sitesCurrentMax[id]["currentMaxAqi"] > 0) {
                        let hour = sitesCurrentMax[id]["currentMaxHour"];
                        if (hour > 12) {
                            if (hour === 24) {
                                hour = "12am"
                            } else {
                                hour = hour - 12 + "pm";
                            }
                        } else {
                            if (hour === 12) {
                                hour = "12pm";
                            } else {
                                hour = hour + "am";
                            }
                        }

                        content = siteMap[id]["name"]
                            + "<br/>"
                            + "Current Max AQI: " + sitesCurrentMax[id]["currentMaxAqi"] + ", " + sitesCurrentMax[id]["currentMaxCategory"]
                            + "<br/>"
                            + "Pollutant: " + sitesCurrentMax[id]["currentMaxParameterName"]
                            + "<br/>"
                            + hour;
                    } else {
                        content = siteMap[id]["name"]
                            + "<br/>"
                            + "No AQI data";
                    }

                    popupOverlay.setPosition([window.jQuery(this).attr("location").split(",")[0], window.jQuery(this).attr("location").split(",")[1]]);
                    window.jQuery(element).popover({
                        'animation': false,
                        'html': true,
                        'content': content
                    });
                    window.jQuery(element).popover('show');

                    window.jQuery(this).addClass("monitor-marker-hover");
                }, function () {
                    window.jQuery(element).popover('dispose');
                    window.jQuery(this).removeClass("monitor-marker-hover");
                });

                map.addOverlay(marker);
            }
        }
        for (let i = 0; i < window.jQuery(".ol-overlay-container").length; i++) {
            // console.log(window.jQuery(window.jQuery(".ol-overlay-container")[i]).children().hasClass("monitor-live"));
            if (window.jQuery(window.jQuery(".ol-overlay-container")[i]).children().hasClass("monitor-live")) {
                window.jQuery(window.jQuery(".ol-overlay-container")[i]).addClass("active-monitor-z");
            }
        }
        populateSelect();
    }

    function getMonitorClass(siteId) {
        let monitorClass = "";

        let currentMax = sitesCurrentMax[siteId]["currentMaxAqi"];

        if (currentMax > 0 && currentMax < 51) {
            monitorClass = "monitor-marker monitor-live monitor-good";
        } else {
            if (currentMax < 101) {
                monitorClass = "monitor-marker monitor-live monitor-moderate";
            } else {
                if (currentMax < 151) {
                    monitorClass = "monitor-marker monitor-live monitor-ufsg";
                } else {
                    if (currentMax < 201) {
                        monitorClass = "monitor-marker monitor-live monitor-unhealthy";
                    } else {
                        monitorClass = "monitor-marker monitor-live monitor-very-unhealthy";
                    }
                }
            }
        }

        if (currentMax <= 0) {
            monitorClass = "monitor-marker monitor-na";
        }

        return monitorClass;
    }

    function populateSelect() {
        let monitorSelect = window.jQuery("#monitorSelect");
        if (siteMap) {
            window.jQuery.each(siteMap, function (id, data) {
                monitorSelect.append(window.jQuery('<option>', {
                    value: data.name,
                    text: data.name
                }));
            });
            sortOptions("monitorSelect");
            monitorSelect.on('change', function (e) {
                let site = window.jQuery("#monitorSelect option:selected").val();
                updateMaxAqi = true;
                getDataForSiteParameterDate(getSiteIdForSiteName(site), siteMap[getSiteIdForSiteName(site)]['measuredParameters'][0], window.jQuery('#datePicker').data('DateTimePicker').date(), window.jQuery("#" + paramButtonMap[siteMap[getSiteIdForSiteName(site)]['measuredParameters'][0]]));
                // updateMaxAqiGauge(getSiteIdForSiteName(site), 0);
            });
        }
    }

    function sortOptions(id) {
        let options = window.jQuery('#' + id + ' option');
        let arr = options.map(function (_, o) {
            return {
                t: window.jQuery(o).text(),
                v: o.value
            };
        }).get();
        arr.sort(function (o1, o2) {
            return o1.t > o2.t ? 1 : o1.t < o2.t ? -1 : 0;
        });
        options.each(function (i, o) {
            o.value = arr[i].v;
            window.jQuery(o).text(arr[i].t);
        });
    }

    /**********************************
     * Select the image for current AQI
     *********************************/
    function getIconForCategoryCurrentMaxRegion(icons, regions, allSites) {
        let icon = icons[6]["url"]; // N/A image by default
        const aqiVar = "currentMaxAqi";

        let maxAqi = -1;
        regions.forEach((region, index) => {
            let currentAqi = allSites[region][aqiVar];
            if (currentAqi > maxAqi) {
                if (allSites[region][aqiVar] !== null && allSites[region][aqiVar] !== undefined) {
                    maxAqi = currentAqi;
                }
            }
        });

        if (maxAqi <= 50) {
            icon = icons[0]["url"];
        } else if (maxAqi <= 100) {
            icon = icons[1]["url"];
        } else if (maxAqi <= 150) {
            icon = icons[2]["url"];
        } else if (maxAqi <= 200) {
            icon = icons[3]["url"];
        } else if (maxAqi <= 300) {
            icon = icons[4]["url"];
        }

        return icon;
    }

    return function destroy() {
        // Destroy map
        if (currentMap !== undefined) {
            currentMap.setTarget(null);
        }

        // Destroy charts
        if (chartAQI !== undefined) {
            // chartAQI.current.chart.destroy();
        }

        // Destroy async jsonp request
        if (script !== undefined) {
            document.body.removeChild(script);
        }
        if (document.body.contains(script)) {
            document.body.removeChild(script);
        }
        if (window.callback) {
            delete window.siteDataCallback;
        }

        // Destroy chart control events
        window.jQuery('#datePicker').datetimepicker().off('dp.change');
        window.jQuery('#datePicker').datetimepicker('remove');
        window.jQuery("#previousDay").off('click');
        window.jQuery("#nextDay").off('click');
        window.jQuery(".parameter-button").off('click');
        window.jQuery("#monitorSelect").off('change');
        window.jQuery("#monitorSelect").empty();
    }
}

function CurrentAirQualityDisplay({ aqiCategoryIcons, sitesData, sitesPerRegion, mapRegions, isActive, today }) {
    const mapElement = useRef(null);

    useEffect(() => {
        if (isActive === true) {
            let destroyCallback = displayLogic(mapElement.current, mapRegions.regions, aqiCategoryIcons, sitesData, sitesPerRegion);
            return () => {
                destroyCallback();
            };
        }
    }, [isActive]);

    const createIconByRegionSiteData = (region) => {
        let maxAqi = -1;
        let aqiCategory = "Not Available";
        for (let site of region.sites) {
            let aqi = sitesData[site].currentMaxAqi;
            if (aqi > maxAqi) {
                maxAqi = aqi;
                aqiCategory = sitesData[site].currentMaxCategory;
            }
        }
        let icon;
        if (aqiCategory === "Good") {
            icon = aqiCategoryIcons[0];
        } else if (aqiCategory === "Moderate") {
            icon = aqiCategoryIcons[1];
        } else if (aqiCategory === "Unhealthy") {
            icon = aqiCategoryIcons[2];
        } else if (aqiCategory === "Unhealthy for Sensitive Groups") {
            icon = aqiCategoryIcons[3];
        } else if (aqiCategory === "Very Unhealthy") {
            icon = aqiCategoryIcons[4];
        } else if (aqiCategory === "Not Available" || aqiCategory === "") {
            icon = aqiCategoryIcons[6];
        } else {
            icon = aqiCategoryIcons[4];  // Very Unhealthy for everything else
        }
        return (
            // It is currently required to use 'forecast-icon' class, though it really should be called 'current-icon'.
            <img className="img-responsive forecast-icon"
                 alt={ icon.alternativeText }
                 src={ icon.url } />
        );
    };

    return (
        <div className={"tab-pane " + (isActive === true ? "active" : "")} id="current">

            <div className="map" ref={mapElement} id="currentMap"></div>

            <div className="section-headline center-align full-width footer-blue white-text" style={{ padding: "10px 0px" }}>
                Current Air Quality
            </div>

            <div className="col-xs-12 no-padding region-forecast-container ">
                <div className="blue-gradient region-forecast-display">
                    <div className="vertical-align region-forecast-display">
                        <div className="col-sm-12 center-align ">

                            <table className="white-text" style={{ width: "100%" }} id="forecastRegionTable">

                                <tbody>

                                <tr>
                                    <th>NORTHERN VA/DC</th>
                                    <th>METRO BALTIMORE</th>
                                    <th>MARYLAND PIEDMONT</th>
                                    <th>NORTHERN BALTIMORE</th>
                                </tr>

                                <tr id="northernVirginiaForecast">
                                    <td className="forecast-cell-bottom-left">
                                        { createIconByRegionSiteData( sitesPerRegion[2] ) }
                                    </td>
                                    <td className="forecast-cell-bottom-left">
                                        { createIconByRegionSiteData( sitesPerRegion[1] ) }
                                    </td>
                                    <td className="forecast-cell-bottom-left">
                                        { createIconByRegionSiteData( sitesPerRegion[3] ) }
                                    </td>
                                    <td className="">
                                        { createIconByRegionSiteData( sitesPerRegion[4] ) }
                                    </td>
                                </tr>

                                <tr>
                                    <th>NORTHEAST MARYLAND</th>
                                    <th>SUBURBAN DC</th>
                                    <th>UPPER EASTERN SHORE</th>
                                    <th>SOUTHERN MARYLAND</th>
                                </tr>

                                <tr id="suburbanDcForecast">
                                    <td className="forecast-cell-bottom-left">
                                        { createIconByRegionSiteData( sitesPerRegion[5] ) }
                                    </td>
                                    <td className="forecast-cell-bottom-left">
                                        { createIconByRegionSiteData( sitesPerRegion[6] ) }
                                    </td>
                                    <td className="forecast-cell-bottom-left">
                                        { createIconByRegionSiteData( sitesPerRegion[7] ) }
                                    </td>
                                    <td className="">
                                        { createIconByRegionSiteData( sitesPerRegion[8] ) }
                                    </td>
                                </tr>

                                </tbody>

                            </table>
                        </div>
                    </div>

                    <span>
                        <img alt="legend" className="full-width" src={ aqiCategoryIcons[5].url } />
                    </span>
                </div>
            </div>

            <div className="container current-menu-bar">
                <div className="row" style={{ display: "flex" }}>
                    <div className="col-xs-12 col-sm-7 col-md-5 col-lg-4">

                        <div style={{ display: "inline-block" }}>
                            <button type="button" className="btn change-button" id="previousDay">Previous</button>
                        </div>

                        <div className="date-picker-container">
                            <div className="input-group mb-3 date" id="datePicker">
                                <input type="text" className="form-control" style={{ fontSize: "14px" }}/>
                                <span className="input-group-text input-group-addon" >
                                    <i className="bi bi-calendar3"></i>
                                </span>
                            </div>
                        </div>


                        <div style={{ display: "inline-block" }}>
                            <button type="button" className="btn btn-secondary change-button" id="nextDay">Next</button>
                        </div>

                    </div>

                    <div className="col-xs-12 col-sm-5 col-md-3 col-lg-3 form-group" style={{ paddingRight: "5px" }}>
                        <select className="form-control form-select" id="monitorSelect">
                        </select>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-4 col-lg-5 center-align chart-button-bar" role="group" aria-label="Parameters" style={{ padding: "0" }}>
                        <button type="button" id="ozoneButton" data-param="1" className="btn parameter-button">Ozone</button>
                        <button type="button" id="pm25Button" data-param="2" className="btn parameter-button">PM<sub>2.5</sub></button>
                        <button type="button" id="pm10Button" data-param="3" className="btn btn-secondary parameter-button">PM<sub>10</sub></button>
                        <button type="button" id="coButton" data-param="5" className="btn btn-secondary parameter-button">CO</button>
                        <button type="button" id="so2Button" data-param="9" className="btn btn-secondary parameter-button">SO2</button>
                        <button type="button" id="tempButton" data-param="22" className="btn parameter-button">Temp</button>
                        <button type="button" id="rhButton" data-param="25" className="btn btn-secondary parameter-button">RH</button>
                        <button type="button" id="wsButton" data-param="23" className="btn btn-secondary parameter-button">WS</button>
                        <button type="button" id="wdButton" data-param="24" className="btn btn-secondary parameter-button">WD</button>
                    </div>
                </div>
            </div>

            <div className="container region-current-display">
                <div className="row" style={{ display: "flex" }}>
                    <div className="col-xs-12 col-sm-5 no-padding" id="gaugeDisplay">
                        <div className="center-align current-max-text">
                            <span className="section-headline-small" style={{ color: "#fff", fontWeight: "400 !important" }}>
                                Daily Max AQI
                            </span>
                        </div>
                        <div id="gaugeContainer" className="forecast-gauge center-align">
                        </div>
                    </div>

                    <div className="col-xs-12 col-sm-7 no-padding">
                        <div id="aqiBarGraph" className=""></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CurrentAirQualityDisplay;
